import RecommendationLink from 'components/Nav/subcomponents/RecommendationLink'
import RecommendationsMain from 'components/Nav/subcomponents/RecommendationsMain'
import SecurityLink from 'components/Nav/subcomponents/SecurityLink'
import AuditsLink from 'components/Nav/subcomponents/AuditsLink'
import BenchmarksLink from 'components/Nav/subcomponents/BenchmarksLink'

export default {
  'recommendations/main': RecommendationsMain,
  'recommendations/audits': AuditsLink,
  'recommendations/benchmarks': BenchmarksLink,
  'recommendations/campaigns': RecommendationLink,
  'user/security': SecurityLink,
}
